import React from "react";
import { TopBar } from "@/components/TopBar";
import { apiJerseySiapDesain, formatApiErrorDetail } from "@/lib/api";
import { tanggalIndo } from "@/lib/format";
import { STATUS_JERSEY } from "@/pages/JerseyDetail";
import { Loader2, RefreshCw, ChevronDown, ChevronRight } from "lucide-react";

// CS (role desain): jersey orders still in progress, with players and sizes for
// the design. The endpoint never returns prices, totals or payments.
export default function JerseySiapDesain() {
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const load = React.useCallback(async () => {
    setLoading(true);
    try { setRows(await apiJerseySiapDesain()); setError(null); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  }, []);
  React.useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="jersey-desain-page" className="min-h-screen bg-slate-950 text-slate-200">
      <TopBar />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <div className="flex items-end justify-between gap-3">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-100">Order Jersey · Desain</h1>
            <p className="text-sm text-slate-400 mt-1">Data untuk desain dan konfirmasi ke customer (tanpa harga). Daftar nama adalah data pribadi — jangan dibagikan di luar keperluan order.</p>
          </div>
          <button onClick={load} className="inline-flex items-center gap-1.5 text-xs font-mono text-slate-400 hover:text-slate-200"><RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Refresh</button>
        </div>
        {error && <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-2.5 text-sm text-red-300">{error}</div>}
        {loading && <Loader2 className="animate-spin text-slate-400" />}
        {rows.map((r) => {
          const [label, cls] = STATUS_JERSEY[r.status_jersey] || [r.status_jersey, ""];
          return (
            <div key={r.id} data-testid={`jersey-desain-${r.nomor_faktur}`} className="rounded-xl border border-slate-800 bg-slate-900/60 p-4 space-y-2">
              <button onClick={() => setOpen({ ...open, [r.id]: !open[r.id] })} className="w-full flex flex-wrap items-center gap-3 text-left">
                {open[r.id] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                <span className="font-mono text-amber-300">{r.nomor_faktur}</span>
                <span>{r.customer_nama}</span><span className="text-slate-500">{r.tim_komunitas}</span>
                <span className={`rounded-md border px-2 py-0.5 text-xs font-mono ${cls}`}>{label}</span>
                <span className="text-xs text-slate-400">{r.total_pcs} pcs · {r.cara_serah === "KIRIM" ? "kirim" : "ambil"} {tanggalIndo(r.tanggal_ambil_kirim)} · produksi: {r.status_spk === "READY" ? r.status_produksi : "belum masuk antrean"}</span>
              </button>
              {open[r.id] && (
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-2 text-sm">
                  <div className="space-y-1">
                    <div className="text-xs font-mono uppercase text-slate-500">PIC</div><div>{r.pic_nama || "—"} <span className="text-slate-400">{r.pic_whatsapp}</span></div>
                    <div className="text-xs font-mono uppercase text-slate-500 pt-2">Produk</div>
                    {r.variasi.map((v) => <div key={v.baris_no}>V{v.baris_no}: {v.nama_barang} × {v.quantity}<div className="text-xs text-slate-400">{[v.jenis_jersey, v.model, v.kerah, v.bahan, v.warna, v.motif, v.cutting].filter(Boolean).join(" / ")}</div></div>)}
                    {r.tambahan.map((t, i) => <div key={i} className="text-xs text-slate-400">+ {t.nama_barang} × {t.quantity}</div>)}
                    <div className="text-xs font-mono uppercase text-slate-500 pt-2">Ukuran</div>
                    <div className="text-xs">{Object.entries(r.ukuran || {}).filter(([, n]) => n).map(([u, n]) => `${u}: ${n}`).join(" · ")}</div>
                    {r.ukuran_custom_catatan && <div className="text-xs text-slate-400">Custom: {r.ukuran_custom_catatan}</div>}
                  </div>
                  <div className="lg:col-span-2 max-h-80 overflow-y-auto">
                    <table className="w-full text-sm"><thead><tr className="text-left text-xs text-slate-500"><th>#</th><th>Nama</th><th>Nomor</th><th>Ukuran</th><th>Lengan</th><th>Catatan</th></tr></thead>
                      <tbody>{r.pemain.map((p, i) => <tr key={i}><td className="text-xs text-slate-500">{i + 1}</td><td>{p.nama}</td><td className="font-mono">{p.nomor}</td><td className="font-mono">{p.ukuran}</td><td className="text-xs">{p.lengan}</td><td className="text-xs text-slate-400">{p.catatan}</td></tr>)}</tbody></table>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        {!loading && rows.length === 0 && <div className="text-slate-500">Tidak ada order Jersey yang sedang berjalan.</div>}
      </main>
    </div>
  );
}
